// @flow

import * as React from 'react';

type Props = {
  className?: string,
  href: string,
  imageUri: string
};

const defaultProps = {
  className: undefined
};

function AppLink({ className, href, imageUri }: Props) {
  return (
    <a key={href} href={href} rel="noopener noreferrer" target="_blank">
      <img className={className} src={imageUri} alt="" />
    </a>
  );
}

AppLink.defaultProps = defaultProps;

export default AppLink;
